import { BaseSuperAgentRequestFactory } from '@studyportals/mb-platform-http-requests';
import { EmboClient } from '@studyportals/sp-embo-interface';

import { RequestSender } from './';

const emboUrl = webpackDefinitions.VUE_APP_EMBO_URL;
const embo = new EmboClient(new BaseSuperAgentRequestFactory(), RequestSender, emboUrl);

export default embo;
